// Links the theme's Consentmo overrides (components/cookie-banner/) into the
// open shadow root of the app's `csm-cookie-consent` element, which page CSS
// cannot reach. The app appends its own stylesheets the same way, and ours
// lands after them.

const STYLESHEET_URL = window.theme?.cookie_banner_styles_url;
const LINK_ATTRIBUTE = "data-theme-cookie-banner-styles";

const injectStyles = () => {
  const shadowRoot = document.querySelector("csm-cookie-consent")?.shadowRoot;
  if (!shadowRoot) return false;

  if (!shadowRoot.querySelector(`[${LINK_ATTRIBUTE}]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = STYLESHEET_URL;
    link.setAttribute(LINK_ATTRIBUTE, "");
    shadowRoot.appendChild(link);
  }

  return true;
};

if (STYLESHEET_URL && !injectStyles()) {
  // The app appends its host directly to `body` and attaches the shadow root
  // synchronously in `connectedCallback`, so watching direct children is
  // enough — no subtree walk needed.
  const observer = new MutationObserver(() => {
    if (injectStyles()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true });
}
